/**
 * NOS-58: Slug utilities for custom page creation.
 * Auto-generation, reserved slug validation, and uniqueness checks.
 */

/** Reserved slugs that cannot be used for custom pages (conflict with routes or system) */
export const RESERVED_SLUGS = new Set([
  "blog",
  "donate",
  "about",
  "contact",
  "events",
  "dashboard",
  "admin",
  "settings",
  "api",
  "home",
])

/**
 * Generate a URL-friendly slug from a title.
 * Lowercase, replace spaces with hyphens, strip special characters.
 */
export function generateSlug(title: string): string {
  return title
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-") // collapse multiple hyphens
    .replace(/^-|-$/g, "") // trim leading/trailing hyphens
    || "new-page"
}

/**
 * Check if a slug is reserved. Returns error message or null if valid.
 */
export function validateReservedSlug(slug: string): string | null {
  const normalized = slug.trim().toLowerCase()
  if (!normalized) return "Slug is required"
  if (RESERVED_SLUGS.has(normalized)) {
    return `"${slug}" is reserved. Choose a different URL path.`
  }
  return null
}
